import styled from 'styled-components'
import { H2 } from '../../../elements/typography'
import { media } from '../../../style/media'

export const ListTitle = styled(H2)`
  padding-left: ${(props) => props.theme.spacing.xsmall}px;
  font-size: ${(props) => props.theme.fontSizes.larger}px;
  ${media.sm`
    font-size: ${(props) => props.theme.fontSizes.larger + 2}px;
  `};
  ${media.md`
    font-size: ${(props) => props.theme.fontSizes.xlarge}px;
  `};
`
